import { useColorMode, useColorStyle } from '@tonic-one/react';

const useCheckStyle = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const checkedColorStyle = (
    {
      light: {},
      dark: {
        color: colorStyle.color.success,
      },
    } as any
  )[colorMode];
  const unCheckedColorStyle = (
    {
      light: {},
      dark: {
        color: colorStyle.color.tertiary,
      },
    } as any
  )[colorMode];
  return {
    checked: checkedColorStyle,
    unChecked: unCheckedColorStyle,
  };
};

const useActiveMenuStyle = () => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  return {
    backgroundColor: colorStyle.background.selected,
    borderLeft: '2px solid #e52630',
  };
};

export { useCheckStyle, useActiveMenuStyle };
